// Boot splash — shown during session probe and the first fleet-snapshot load.

import { C, MONO } from '../lib/tokens';

export function BootSplash({ message }: { message?: string }) {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 100,
        background: C.bg,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14, width: 280 }}>
        <div style={{ fontFamily: MONO, fontSize: 13, letterSpacing: '.28em', color: C.dm }}>WATCHTOWER</div>
        <div
          style={{
            width: 26,
            height: 26,
            border: '2px solid ' + C.ln,
            borderTopColor: C.bl,
            borderRadius: '50%',
            animation: 'wt-spin .8s linear infinite',
          }}
        />
        <div style={{ fontSize: 12, color: C.dm }}>{message ?? 'Connecting to monitoring backend…'}</div>
        <div style={{ width: '100%', height: 6, background: C.s2, borderRadius: 3, animation: 'wt-pulse 1.4s ease infinite' }} />
        <div style={{ width: '82%', height: 6, background: C.s2, borderRadius: 3, animation: 'wt-pulse 1.4s .2s ease infinite' }} />
      </div>
    </div>
  );
}
